if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"account": 1,
"admin": 1,
"admin-permissions": 1,
"admin-settings": 1,
"asyncCommons-admin_app_selectors_ts-admin_components_AdminContentTable_index_tsx-admin_compon-5ef7dd": 1,
"asyncCommons-collections_components_CollectionContent_index_ts-archive_components_ArchivedEnt-856f84": 1,
"asyncCommons-common_components_ActionButton_index_tsx-common_components_Toaster_Toaster_tsx-c-a9554f": 1,
"asyncCommons-common_utils_collections_ts-metadata_components_TableSortableFieldList_index_ts--9b2aec": 1,
"asyncCommons-dashboard_components_Dashboard_Dashboard_tsx-visualizations_components_ChartTool-229307": 1,
"asyncCommons-data-grid_index_ts-ui_components_data-display_SortableHeaderPill_SortableHeaderP-e49d89": 1,
"asyncCommons-documents_components_editor-extensions_CardEmbed_CardEmbedNode_tsx-metabot_compo-97fb06": 1,
"asyncCommons-embedding_setup-guide_index_ts": 1,
"asyncCommons-metabot_components_MetabotChat_MetabotChat_tsx-common_components_SaveQuestionFor-ac625a": 1,
"asyncCommons-query_builder_containers_QueryBuilder_tsx-common_components_TimelineEventInfo_Ti-d47811": 1,
"asyncCommons-querying_components_DataReference_DataReference_tsx-querying_components_NativeQu-948c9d": 1,
"asyncCommons-resources_frontend_client_app_assets_img_empty-states_code_svg-common_components-84fc2b": 1,
"asyncCommons-visualizations_components_LeafletChoropleth_tsx": 1,
"automatic-dashboard": 1,
"browse": 1,
"code-editor": 1,
"comments-sidesheet": 1,
"common_components_SaveQuestionForm_SaveQuestionForm_module_css-metabot_components_MetabotProm-e281b7": 1,
"common_utils_collections_ts-querying_action-creator_ActionCreator_tsx-querying_constants_ts-q-168193": 1,
"dashboard-move-modal": 1,
"data-model": 1,
"data-studio": 1,
"data-studio-glossary": 1,
"data-studio-upsells": 1,
"documents": 1,
"embedding-hub_pages_EmbeddingHubThemeEditorPage_tsx": 1,
"embedding-hub_pages_index_ts-common_components_upsells_components_UpsellBanner_module_css-com-411d4b": 1,
"embedding_embedding-iframe-sdk-setup_components_LegacyStaticEmbeddingModal_tsx-common_compone-574ca3": 1,
"embedding_embedding-iframe-sdk-setup_components_SdkIframeEmbedSetupModal_tsx-common_component-f85bdb": 1,
"expression-editor": 1,
"home": 1,
"metabot": 1,
"metabot-suggestion-preview": 1,
"metrics": 1,
"metrics-viewer": 1,
"monitor": 1,
"monitor-notifications": 1,
"monitor-tasks": 1,
"nav_components_AreaLayout_AreaLayout_module_css": 1,
"onboarding": 1,
"public-document": 1,
"query-editor": 1,
"query_builder_components_MetabotQueryBuilder_MetabotQueryBuilder_tsx-metabot_components_Metab-fb70e9": 1,
"reference": 1,
"search": 1,
"setup": 1,
"timelines": 1,
"transforms": 1,
"user-collection-list": 1,
"visualizations_components_ChartTooltip_KeyValuePairChartTooltip_KeyValuePairChartTooltip_modu-722ed7": 1,
"viz-area": 1,
"viz-bar": 1,
"viz-boxplot": 1,
"viz-combo": 1,
"viz-funnel": 1,
"viz-line": 1,
"viz-list": 1,
"viz-map": 1,
"viz-object-detail": 1,
"viz-pie": 1,
"viz-row": 1,
"viz-scalar": 1,
"viz-scatter": 1,
"viz-smart-scalar": 1,
"viz-table": 1,
"viz-treemap": 1,
"viz-waterfall": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload